import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { EmployerBrandingPersonaPageBG } from "@/components/site/EmployerBrandingPersonaPageBG";
import { EMPLOYER_BRANDING_META_DESCRIPTION_BG } from "@/content/meta/EmployerBrandingPersonaPageBG";

export const Route = createFileRoute("/bg/who-we-help/employer-branding-experts")({
  head: () => ({
    meta: [
      { title: "Медийно разузнаване за HR и employer branding | Perceptica" },
      { name: "description", content: EMPLOYER_BRANDING_META_DESCRIPTION_BG },

      { property: "og:title", content: "Медийно разузнаване за HR и employer branding | Perceptica" },
      { property: "og:description", content: EMPLOYER_BRANDING_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медийно разузнаване за HR и employer branding | Perceptica" },
      { name: "twitter:description", content: EMPLOYER_BRANDING_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/who-we-help/employer-branding-experts" },
      ...ogImageMeta("bg", "/who-we-help/employer-branding-experts"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/who-we-help/employer-branding-experts" }),
  }),
  component: EmployerBrandingPersonaPageBG,
});
